import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'params/units',
        component: () => import(/* webpackChunkName: "units" */ '@/views/params/Units.vue')
      },
      {
        path: 'params/record',
        component: () => import(/* webpackChunkName: "record" */ '@/views/params/Record.vue')
      },
      {
        path: 'params/record-detail',
        component: () => import(/* webpackChunkName: "record-detail" */ '@/views/params/RecordDetail.vue')
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path !== '/login' && store.getters.getToken === null) next('/login')
  else next()
})

export default router
